import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useCoupons = (page = 1, limit = 100, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["coupons", page, limit, search],
    () =>
      fetchData(
        `/coupons?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
      ),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        coupons: response?.data || [],
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (coupon) => {
      const method = coupon.id ? "PUT" : "POST";
      const endpoint = coupon.id ? `/coupons/${coupon.id}` : `/coupons`;
      return fetchData(endpoint, method, coupon);
    },
    { onSuccess: () => queryClient.invalidateQueries("coupons") }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/coupons/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("coupons") }
  );

  return { ...query, updateMutation, deleteMutation };
};
